import Header from "../../header";
import Footer from "../../footer";
import ContactForm from "../../contactcomponents/contactform";
import BannerFooter from "./bannerForFooter";
import tradingplatform from '../../../images/footerLinksImages/productImage/tradingplatform.jpg';
function TradingPlatform() {

    const platforms = [
        {
          title: "User-Friendly Interface",
          description: "Our platforms are designed with intuitive dashboards, making trading accessible for both beginners and seasoned traders.",
        },
        {
          title: "Real-Time Market Data",
          description: "Stay ahead of the curve with up-to-the-second market updates and analytics for informed decision-making.",
        },
        {
          title: "AI-Powered Insights",
          description: "Leverage advanced algorithms to identify patterns, predict market trends, and optimize your trading strategies.",
        },
        {
          title: "Mobile Compatibility",
          description: "Trade on the go with fully optimized mobile apps, offering the same functionality as desktop versions.",
        },
        {
          title: "Customizable Trading Tools",
          description: "Personalize your trading experience with tools like technical indicators, charting options, and watchlists.",
        },
        {
          title: "Enhanced Security Features",
          description: "Rest assured with robust security measures, including two-factor authentication and encrypted transactions.",
        },
        {
          title: "API Integration",
          description: "Integrate your trading tools seamlessly with APIs for automated and efficient trading workflows.",
        },
        {
          title: "Educational Resources",
          description: "Access tutorials, webinars, and in-depth guides directly on the platform to improve your trading skills.",
        },
        {
          title: "24/7 Customer Support",
          description: "Get assistance whenever you need it with our round-the-clock expert support team.",
        },
        {
          title: "Global Market Access",
          description: "Trade across multiple global markets with ease and diversify your investment portfolio.",
        },
      ];
    return (<>
        <Header />

        <BannerFooter
            title="Advance Trading Platform"
            text="Advanced trading platforms provide traders with cutting-edge tools for seamless market access and decision-making. These platforms integrate real-time data, technical analysis, and automation to enhance efficiency and precision. With features like algorithmic trading, mobile compatibility, and robust security, they cater to beginners and professionals alike. Advanced platforms simplify trading complexities, ensuring speed, transparency, and reliability in diverse financial markets."
            imageone={tradingplatform}
            imagetwo={tradingplatform}
        />

<div className="container my-4">
      <h2 className="text-center mb-4">Advanced Trading Platforms</h2>
      <div className="accordion" id="accordionExample">
        {platforms.map((platform, index) => (
          <div className="accordion-item" key={index}>
            <h2 className="accordion-header" id={`heading${index}`}>
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#collapse${index}`}
                aria-expanded="false"
                aria-controls={`collapse${index}`}
              >
                {platform.title}
              </button>
            </h2>
            <div
              id={`collapse${index}`}
              className="accordion-collapse collapse"
              aria-labelledby={`heading${index}`}
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
                {platform.description}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
        <ContactForm/>


        <Footer />
    </>)
}

export default TradingPlatform